import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap, first } from 'rxjs/operators';
import { Auth, idToken } from '@angular/fire/auth';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private auth: Auth) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return idToken(this.auth).pipe(
      first(),
      switchMap((token: string | null) => {
        const modifiedRequest: HttpRequest<unknown> = request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next.handle(modifiedRequest);
      })
    );
  }
}
